"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollableTableContainer = exports.Table = void 0;
/* eslint-disable react/jsx-props-no-spreading */
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var cell_1 = require("./cell");
var row_1 = require("./row");
var tbody_1 = require("./tbody");
var thead_1 = require("./thead");
exports.Table = (0, react_1.forwardRef)(function (_a, ref) {
    var propTestId = _a.testId, props = __rest(_a, ["testId"]);
    var testId = propTestId !== null && propTestId !== void 0 ? propTestId : 'table';
    return react_1.default.createElement(StyledTable, __assign({}, props, { "data-testid": testId, ref: ref }));
});
function ScrollableTableContainer(_a) {
    var children = _a.children, height = _a.height;
    return (react_1.default.createElement("div", { style: {
            overflowX: 'auto',
            maxWidth: '100%',
            minWidth: '100%',
            width: '100%',
            display: 'block',
            height: height,
        } }, children));
}
exports.ScrollableTableContainer = ScrollableTableContainer;
var StyledTable = styled_components_1.default.div(function (_a) {
    var _b, _c, _d;
    var isSelectable = _a.isSelectable, isSticky = _a.isSticky;
    return (_b = {
            width: '100%',
            minWidth: '100%',
            borderSpacing: 0,
            overflowY: 'auto'
        },
        _b["& .".concat(thead_1.theadClassName, " .").concat(thead_1.thClassName)] = (_c = {
                borderTop: "1px solid ".concat(core_ui_1.colors.border.default),
                borderBottom: "1px solid ".concat(core_ui_1.colors.border.default),
                '.resizer': {
                    display: 'inline-block',
                    background: 'transparent',
                    width: '10px',
                    height: '100%',
                    position: 'absolute',
                    right: 10,
                    top: 0,
                    transform: 'translateX(50%)',
                    zIndex: 1,
                    touchAction: 'none',
                }
            },
            _c[isSticky ? '&:not(:first-child)' : '&'] = {
                '.resizer': {
                    '&:before': {
                        content: "''",
                        borderRight: "1px solid ".concat(core_ui_1.colors.steel[200]),
                        height: '50%',
                        width: '10px',
                        position: 'absolute',
                        right: 0,
                        bottom: '50%',
                        transform: 'translate(-50%, 50%)',
                        visibility: 'hidden',
                    },
                    '&:hover:before': {
                        visibility: 'visible',
                    },
                    '&.isResizing': {
                        '&:before': {
                            visibility: 'visible',
                            cursor: 'resize',
                            borderRight: "1px solid ".concat(core_ui_1.colors.steel[400]),
                        },
                    },
                },
            },
            _c),
        _b["& .".concat(tbody_1.tbodyClassName, " .").concat(cell_1.tdClassName)] = {
            margin: 0,
            borderBottom: "1px solid ".concat(core_ui_1.colors.border.default),
            borderTop: 0,
            borderRight: 0,
            borderLeft: 0,
            fontFamily: core_ui_1.fontFamilies.body,
            fontSize: core_ui_1.fontSizes.regular.fontSize,
            backgroundColor: 'transparent',
        },
        _b["& .".concat(row_1.trClassName)] = {
            '&:last-child': (_d = {},
                _d["& .".concat(cell_1.tdClassName)] = {
                    borderBottom: isSticky ? 0 : "1px solid ".concat(core_ui_1.colors.border.default),
                },
                _d),
        },
        _b["& .newfront-spreadsheet--tbody .".concat(row_1.trClassName, " .").concat(cell_1.tdClassName, ":first-child")] = isSticky
            ? {
                position: 'sticky',
                left: 0,
                zIndex: 1,
                borderSpacing: 0,
                borderRight: "1px solid ".concat(core_ui_1.colors.border.default),
                backgroundColor: '#fff',
            }
            : undefined,
        _b["& .newfront-spreadsheet--tbody .".concat(row_1.trClassName, " .").concat(cell_1.tdClassName, ":nth-child(2)")] = isSelectable && isSticky
            ? {
                position: 'sticky',
                left: 40,
                zIndex: 1,
                borderSpacing: 0,
                borderRight: "1px solid ".concat(core_ui_1.colors.border.default),
                backgroundColor: '#fff',
            }
            : undefined,
        _b["& .".concat(thead_1.theadClassName, " .").concat(row_1.trClassName, " .").concat(thead_1.thClassName, ":first-child")] = isSticky
            ? {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                position: 'sticky !important',
                left: 0,
                zIndex: 2,
                borderRight: "1px solid ".concat(core_ui_1.colors.border.default),
            }
            : undefined,
        _b["& .".concat(thead_1.theadClassName, " .").concat(row_1.trClassName, " .").concat(thead_1.thClassName, ":nth-child(2)")] = isSelectable && isSticky
            ? {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                position: 'sticky !important',
                left: 40,
                zIndex: 2,
                borderRight: "1px solid ".concat(core_ui_1.colors.border.default),
                backgroundColor: '#fff',
            }
            : undefined,
        _b);
});
